import React, { useMemo } from 'react'
import IncompleteWizardBanner from 'components/libs/banner/IncompleteWizardBanner'
import GlobalMessageBanner from 'components/libs/banner/globalMessageBanner/GlobalMessageBanner'
import { useBannersLogic } from 'components/libs/banner/useBannersLogic'
import PreMailflowBanner from 'components/libs/banner/PreMailflowBanner'
import AccountStatusBannerSelector from 'components/libs/banner/accountStatusBanner/AccountStatusBannerSelector'
import RiskyConfigBannerSelector from 'components/libs/banner/riskyConfigBanner/RiskyConfigBannerSelector'

const Banners = () => {
  const [
    {
      wizardUrl,
      incompleteWizardBanner,
      preMailflowBanner,
      accountStatusBannerSelectorProps,
      riskyConfigBannerSelectorProps
    }
  ] = useBannersLogic()
  return useMemo(
    () => (
      <>
        {incompleteWizardBanner && <IncompleteWizardBanner wizardUrl={wizardUrl} />}
        {preMailflowBanner && <PreMailflowBanner />}
        <AccountStatusBannerSelector {...accountStatusBannerSelectorProps} />
        <RiskyConfigBannerSelector {...riskyConfigBannerSelectorProps} />
        <GlobalMessageBanner />
      </>
    ),
    [
      accountStatusBannerSelectorProps,
      riskyConfigBannerSelectorProps,
      incompleteWizardBanner,
      preMailflowBanner,
      wizardUrl
    ]
  )
}

export default Banners
